import React from 'react';
import { toLower } from 'lodash';

const FEEDBACK_LIKES = ['liked', 'normal', 'notLiked', 'cry'];

export const feedbackStats = (cards) => {
  const stats = FEEDBACK_LIKES.map(k => {
    const key = toLower(k);
    const v = cards[k] || 0;
    return (
      <div className='o-feedback-stats__item u-margin-right--small' key={`fb-${key}`}>
        <i className={`sp-icon-feedback-${key} cs-txt--sp-feedback-${key} fa-2x u-margin-bottom--tiny`}></i>
        <small>{v}</small>
      </div>
    );
  });
  return (
    <div className='o-feedback-stats'>
      {stats}
    </div>
  )
}
